// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=SUSE:wght@100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Estilo global para el fondo de la página */\r\n\r\n/* Cabecera */\r\n.formularioEncuesta__header__nVDZN,\r\n.formularioEncuesta__footer__gLSo7 {\r\n  height: 100px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 24px;\r\n}\r\n\r\n/* Zona para que las preguntes ocupen toda la pagina */\r\n.formularioEncuesta__zonaPreguntasFull__1qKht {\r\n  width: 100%;\r\n\r\n  /*height: 250px;*/\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "formularioEncuesta__header__nVDZN",
	"footer": "formularioEncuesta__footer__gLSo7",
	"zonaPreguntasFull": "formularioEncuesta__zonaPreguntasFull__1qKht"
};
export default ___CSS_LOADER_EXPORT___;
